var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingSidesNone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_130)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingSidesNone);
export default __webpack_public_path__ + "static/media/padding_sides_none.9cb0cb3466da7e4ba9da0ee3045dc8a7.svg";
export { ForwardRef as ReactComponent };